import "./styles.css";
import React from "react";
import { Icon, Button } from "semantic-ui-react";
import { Link } from "react-router-dom";
const PurchaseSuccess = () => {
  return (
    <div className="purchase-success-container">
      <Icon size="huge" name="check circle" style={{ color: "green" }} />
      <h3 className="font-weight-bold pt-4">
        Se ha completado la compra con éxito
      </h3>
      <p className="font-weight-bold" style={{ color: "gray" }}>
        Muy pronto recibirá en su correo la factura con los detalles de la compra.
      </p>
      <div className="pt-5">
        <Link to="/">
          <Button className="btn btn-black text-white">Seguir comprando</Button>
        </Link>
      </div>
    </div>
  );
};
export default PurchaseSuccess;
